<template>
  <span
    v-if="color"
    class="template-color-chip"
    :style="{ backgroundColor: color }"
    data-testid="template-color-chip" />
</template>

<script>
export default {
  name: 'TemplateColorChip',
  props: {
    /** テンプレートを使わずに作成したノートは null */
    color: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.template-color-chip {
  display: inline-block;
  flex-shrink: 0;
  width: 5px;
  // 呼び出し元ごとに文字サイズが違うため、高さは文字に追従させる。
  // vertical-align はベースライン基準で、em ボックスと上下が揃う値
  height: 1em;
  margin-right: 4px;
  // ノートテンプレート一覧の色バー（9px 幅で 3px）と見た目の丸みを揃える。
  // 幅が 5px のため同じ 3px だと丸くなりすぎるので 2px にする
  border-radius: 2px;
  vertical-align: -0.125em;
}
</style>
